import { useEffect, useSyncExternalStore } from "react";
import { reportMaintenance } from "../lib/app-status";
import { createCallOwner, memoizeLoad } from "./call-owner";

// Lazy so livekit-client stays off the home bundle. Prefetching and joining
// share the one import.
export const preloadCall = memoizeLoad(() =>
  import("./controller").then((module) => module.createRoomController),
);

export const activeCall = createCallOwner({
  load: preloadCall,
  onMaintenance: reportMaintenance,
});

export function useActiveCall(roomId?: string) {
  const { call } = useSyncExternalStore(activeCall.subscribe, activeCall.getState);
  return call && (roomId === undefined || call.roomId === roomId) ? call : null;
}

export function useMaintenanceResets() {
  return useSyncExternalStore(activeCall.subscribe, () => activeCall.getState().maintenanceResets);
}

const prefetchCall = () => void preloadCall().catch(() => {});

// Fetch the call chunk once the home page is idle, off its critical path.
export function usePrefetchCallWhenIdle() {
  useEffect(() => {
    if (typeof window.requestIdleCallback === "function") {
      const handle = window.requestIdleCallback(prefetchCall, { timeout: 4000 });
      return () => window.cancelIdleCallback(handle);
    }
    const handle = window.setTimeout(prefetchCall, 1500);
    return () => window.clearTimeout(handle);
  }, []);
}

// Hover and focus show intent to join, so start the fetch before the click.
export const prefetchCallOnIntent = { onPointerEnter: prefetchCall, onFocus: prefetchCall };
